export enum ProcessedBrandingProperties {
  BannerImage = 'bannerImage',
  WatermarkImage = 'watermarkImage',
  ProfileImage = 'profileImage',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Profile = 'profile',
  ReleaseZone = 'releaseZone',
  Released = 'released',
}
export enum ProcessedBrandingMetaProperties {
  ProfileId = 'Profile-id',
  ProfileVersion = 'Profile-version',
  ReleaseZoneId = 'ReleaseZone-id',
  ReleaseZoneVersion = 'ReleaseZone-version',
}
